<template>
  <div>
    <b-card style="margin:20px" class="ma-3 ">
      <div>
        <b-row>
          <b-col cols="2" style="width:300px">
            <Sidebar></Sidebar>
          </b-col>
            <div class="mr-1" style="border:solid;width:1px"></div>
          <b-col cols=6>
            <b-row>
              <h2 class="text-cente mx-3">Edi Your Details  - {{ $route.params.id }} </h2>
            </b-row>
            <div>
              <div>
                <div>
                  <b-form-group
                    id="fieldset-horizontal"
                    label-cols-sm="4"
                    label-cols-lg="3"
                    label="User Role"
                  >
                    <b-form-select v-model="selected" :options="options"></b-form-select>
                  </b-form-group>
                </div>
                <div>
                  <b-form-group
                    id="fieldset-horizontal"
                    label-cols-sm="4"
                    label-cols-lg="3"
                    label="Name"
                  >
                    <b-form-input></b-form-input>
                  </b-form-group>
                </div>
                <b-form-group
                  id="fieldset-horizontal"
                  label-cols-sm="4"
                  label-cols-lg="3"
                  label="Email"
                >
                  <b-form-input></b-form-input>
                </b-form-group>
                <div>
                  <b-form-group
                    id="fieldset-horizontal"
                    label-cols-sm="4"
                    label-cols-lg="3"
                    label="Username"
                  >
                    <b-form-input></b-form-input>
                  </b-form-group>
                </div>
                <div>
                  <b-form-group
                    id="fieldset-horizontal"
                    label-cols-sm="4"
                    label-cols-lg="3"
                    label="Password"
                  >
                    <b-form-input type="password"></b-form-input>
                  </b-form-group>
                </div>

                <div>
                  <b-form-group
                    id="fieldset-horizontal"
                    label-cols-sm="4"
                    label-cols-lg="3"
                    label="Mobile Number"
                  >
                    <b-form-input></b-form-input>
                  </b-form-group>
                </div>
                <div>
                  <b-button variant="primary">Submit</b-button>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import Sidebar from "../AdminSlidebar";
export default {
  props: ['userId'],
  name: "AdminEdit",
  components: {
    Sidebar
  }
};
</script>

<style>
</style>